import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";
import { useAppDispatch } from "@/store/hooks";
import { showToast } from "@/store/slices/uiSlice";
import { logger } from "@/utils/logger";
import { useProduct } from "@/hooks/useProduct";

const CheckoutCancelled = () => {
  const config = useProduct();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Log do cancelamento para analytics
    logger.info("[CheckoutCancelled] User cancelled checkout");

    // Opcional: mostrar toast informativo
    dispatch(
      showToast({
        message: "Checkout cancelled. You can try again whenever you want.",
        type: "info",
      })
    );
  }, [dispatch]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-red-100">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-orange-100 flex items-center justify-center">
            <XCircle className="h-8 w-8 text-orange-600" />
          </div>
          <CardTitle className="text-2xl text-orange-900">
            {config.i18n.checkoutCancelled.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-gray-600">
            {config.i18n.checkoutCancelled.message}
          </p>

          <div className="bg-orange-50 p-4 rounded-lg">
            <h3 className="font-semibold text-orange-900 mb-2">
              {config.i18n.checkoutCancelled.whyTitle}
            </h3>
            <ul className="text-sm text-orange-800 space-y-1 text-left">
              <li>{config.i18n.checkoutCancelled.reason1}</li>
              <li>{config.i18n.checkoutCancelled.reason2}</li>
              <li>{config.i18n.checkoutCancelled.reason3}</li>
              <li>{config.i18n.checkoutCancelled.reason4}</li>
            </ul>
          </div>

          <div className="space-y-2">
            <Button onClick={() => navigate("/dashboard")} className="w-full">
              <ArrowLeft className="h-4 w-4 mr-2" />
              {config.i18n.checkoutCancelled.backToDashboard}
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate("/")}
              className="w-full"
            >
              {config.i18n.checkoutCancelled.exploreFree}
            </Button>
          </div>

          <div className="text-xs text-gray-500 mt-4">
            <p>
              {config.i18n.checkoutCancelled.needHelp}{" "}
              <a
                href={`mailto:${config.i18n.checkoutCancelled.supportEmail}`}
                className="text-blue-600 hover:underline"
              >
                {config.i18n.checkoutCancelled.supportEmail}
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutCancelled;
